import axios from 'axios'

const URL = process.env.REACT_APP_API_URL

export const getCatalogues = (params, slug) => {
    const url = `${URL}/catalogues` + (slug ? '/' + slug : '')
    return axios.get(url, { params })
}
